export default __webpack_public_path__ + "static/media/330_dummy2016-coach02-de.0f7ab53b.png";